import { FieldsManagerType } from '.'

export const tableFields: FieldsManagerType[] = [
  {
    tableSection: 'companies',
    whichFieldsToShow: [
      { checked: false, field: 'cnpj', fieldName: 'CNPJ' },
      { checked: false, field: 'cpf', fieldName: 'CPF' },
      { checked: false, field: 'companyName', fieldName: 'Razão social' },
      { checked: false, field: 'stateRegistration', fieldName: 'Inscrição Estadual' },
      { checked: false, field: 'address', fieldName: 'Endereço' },
      { checked: true, field: 'contactName', fieldName: 'Nome do contato' },
      { checked: true, field: 'phone', fieldName: 'Telefone' },
      { checked: true, field: 'email', fieldName: 'E-mail' },
      { checked: true, field: 'companyTypes', fieldName: 'Tipo' },
      { checked: false, field: 'activedDays', fieldName: 'Funcionamento' },
    ]
  },
  {
    tableSection: 'stock',
    whichFieldsToShow: [
      { checked: true, field: 'code', fieldName: 'Código' },
      { checked: true, field: 'material', fieldName: 'Material' },
      { checked: true, field: 'format', fieldName: 'Formato' },
      { checked: true, field: 'finishing', fieldName: 'Acabamento' },
      { checked: true, field: 'fabrication', fieldName: 'Fabricação' },
      {
        checked: false,
        field: 'heatTreatment',
        fieldName: 'Tratamento Térmico',
      },
      { checked: false, field: 'originCountry', fieldName: 'País de Origem' },
      { checked: false, field: 'supplier', fieldName: 'Fornecedor' },
      { checked: false, field: 'stockStreet', fieldName: 'Rua do Estoque' },
      { checked: false, field: 'shelf', fieldName: 'Prateleira' },
      {
        checked: false,
        field: 'stockLocation',
        fieldName: 'Localização no Estoque',
      },
      { checked: false, field: 'ncm', fieldName: 'NCM' },
      { checked: false, field: 'quantity', fieldName: 'Quantidade' },
      { checked: false, field: 'totalWeight', fieldName: 'Peso Total' },
      { checked: false, field: 'dimension1', fieldName: 'Dimensão 1' },
      { checked: false, field: 'dimension2', fieldName: 'Dimensão 2' },
      { checked: false, field: 'lengthInMm', fieldName: 'Comprimento (mm)' },
      { checked: false, field: 'costPerKg', fieldName: 'Custo por Kg' },
      { checked: false, field: 'costPerMm', fieldName: 'Custo por mm' },
      { checked: false, field: 'totalCost', fieldName: 'Custo Total' },
      { checked: false, field: 'invoice', fieldName: 'Nota Fiscal' },
      { checked: false, field: 'density', fieldName: 'Densidade' },
      { checked: false, field: 'certificates', fieldName: 'Certificados' },
      {
        checked: false,
        field: 'availableBalance',
        fieldName: 'Saldo Disponível',
      },
      { checked: false, field: 'totalCmc', fieldName: 'Total CMC' },
      {
        checked: false,
        field: 'trackingNumber',
        fieldName: 'Número de Rastreamento',
      },
      {
        checked: false,
        field: 'receivedDate',
        fieldName: 'Data de Recebimento',
      },
      { checked: false, field: 'purchaseOrder', fieldName: 'Ordem de Compra' },
      { checked: false, field: 'nf', fieldName: 'NF' },
      {
        checked: false,
        field: 'certificateNumber',
        fieldName: 'Número do Certificado',
      },
      { checked: false, field: 'heatNumber', fieldName: 'Número da Corrida' },
      { checked: false, field: 'family', fieldName: 'Família' },
      { checked: false, field: 'description', fieldName: 'Descrição' },
      { checked: false, field: 'status', fieldName: 'Status do Estoque' },
      { checked: false, field: 'characteristic', fieldName: 'Característica' },
      {
        checked: false,
        field: 'measurementUnit',
        fieldName: 'Unidade de Medida',
      },
    ],
  },
  {
    tableSection: 'movement',
    whichFieldsToShow: [
      {
        checked: true,
        field: 'ploomesOrderId',
        fieldName: 'ID do Pedido (Ploomes)',
      },
      {
        checked: true,
        field: 'rawMaterialName',
        fieldName: 'Nome da Matéria-Prima',
      },
      { checked: true, field: 'quantity', fieldName: 'Quantidade' },
      {
        checked: true,
        field: 'oldTotalWeight',
        fieldName: 'Peso Total Anterior',
      },
      { checked: true, field: 'newTotalWeight', fieldName: 'Novo Peso Total' },
      {
        checked: false,
        field: 'oldLengthInMm',
        fieldName: 'Comprimento Anterior (mm)',
      },
      {
        checked: false,
        field: 'newLengthInMm',
        fieldName: 'Novo Comprimento (mm)',
      },
      { checked: false, field: 'status', fieldName: 'Status' },
      { checked: false, field: 'createdAt', fieldName: 'Data de Criação' },
    ],
  },
  {
    tableSection: 'resource',
    whichFieldsToShow: [
      { checked: true, field: 'name', fieldName: 'Insumo' },
      { checked: true, field: 'category', fieldName: 'Categoria' },
      { checked: true, field: 'type', fieldName: 'Tipo' },
      { checked: true, field: 'code', fieldName: 'Código' },
      { checked: true, field: 'price', fieldName: 'Preço' },
      { checked: false, field: 'supplier', fieldName: 'Fornecedor' },
      { checked: false, field: 'description', fieldName: 'Descrição' },
    ],
  },
]
